// todo: remove lodash on client
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';

import IconButton from '@glass/web/components/base/IconButton';
import Menu from '@glass/web/components/base/Menu';
import MoreVertRounded from '@glass/web/components/base/icons/MoreVertRounded';

import ResumeBuilderLink from '@glass/shared/components/Link/ResumeBuilderLink/ResumeBuilderLink';
import IconMenuItem from '@glass/shared/components/Profile/IconMenuItem';
import cardActions, {
  DELETE_CARD_ACTION,
  DUPLICATE_CARD_ACTION,
  EDIT_CARD_ACTION,
} from '@glass/shared/components/Profile/cardActions';

function ResumeCardMenu({ onDelete, onDuplicate, loading, editParams, disabled }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = useCallback((evt) => {
    setAnchorEl(evt.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleDuplicate = useCallback(
    (evt) => {
      handleClose(evt);
      if (typeof onDuplicate === 'function') {
        onDuplicate(evt);
      }
    },
    [handleClose, onDuplicate],
  );

  const handleDelete = useCallback(
    (evt) => {
      handleClose(evt);
      if (typeof onDelete === 'function') {
        onDelete(evt);
      }
    },
    [handleClose, onDelete],
  );

  const menuItems = useMemo(
    () =>
      cardActions.map(({ action: actionProp, key, Icon, title }) => {
        const action = actionProp || key;
        let params = null;
        let onClick = handleClose;

        if (action === EDIT_CARD_ACTION) {
          params = editParams;
        } else if (action === DELETE_CARD_ACTION) {
          onClick = handleDelete;
        } else if (action === DUPLICATE_CARD_ACTION) {
          onClick = handleDuplicate;
        }

        return (
          <IconMenuItem
            key={key}
            component={params ? ResumeBuilderLink : undefined}
            disabled={loading || disabled}
            icon={<Icon fontSize="small" />}
            params={params}
            prefetch={params ? false : undefined}
            title={title || startCase(key)}
            onClick={onClick}
          />
        );
      }),
    [disabled, editParams, handleClose, handleDelete, handleDuplicate, loading],
  );

  return (
    <>
      <IconButton disabled={disabled || loading} size="large" onClick={handleOpen}>
        <MoreVertRounded />
      </IconButton>
      {menuItems ? (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          open={!!anchorEl}
          onClose={handleClose}
        >
          {menuItems}
        </Menu>
      ) : null}
    </>
  );
}

ResumeCardMenu.propTypes = {
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  editParams: PropTypes.object,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
  onDuplicate: PropTypes.func,
};

ResumeCardMenu.defaultProps = {
  loading: false,
};

export default ResumeCardMenu;
